<template>
	<sub-form ref="form">
		<template v-for="(item, i) in config">
			<unit-edit-list v-if="item.type == 'list'" :key="i" ref="complex" :config="item"></unit-edit-list>
			<div v-else-if="item.type == 'group'" :key="i">
				<sub-form-item v-model="dataValue[item.code]" type="radio" :label="item.label" :name="item.code" :options="item.options"></sub-form-item>
				<unit-edit-group ref="complex" :config="item" :current-group="dataValue[item.code]"></unit-edit-group>
			</div>
			<sub-form-item v-else-if="item.type == 'thumb'" :key="i" :label="item.label">
				<sub-radio-group v-model="thumbValue[item.code]" ref="thumb">
					<sub-radio v-for="(style, j) in item.options" :key="j" :value="style.value" style="height: auto;">
						<sub-image :src="style.image" style="width: 160px; height: 160px;"></sub-image>
					</sub-radio>
				</sub-radio-group>
			</sub-form-item>
			<sub-form-item v-else-if="item.type == 'product'" :key="i" :label="item.label">
				<unit-edit-product ref="complex" :code="item.code" :points="pointsProdut[item.code]"></unit-edit-product>
			</sub-form-item>
			<sub-form-item v-else-if="item.type == 'link_area'" :key="i" :label="item.label">
				<unit-edit-link-area ref="complex" :code="item.code"></unit-edit-link-area>
			</sub-form-item>
			<sub-form-item v-else v-model="dataValue[item.code]" v-show="!hidden[item.code]" :key="i" :type="item.type" :label="item.label" :name="item.code" :options="item.options" :multiple="item.multiple" :image-size="item.size" oss :link-type="$route.query.type" :link-template="$route.query.id" @change="unitHandle(item, $event)"></sub-form-item>
		</template>
	</sub-form>
</template>

<script>
	import unitEditList from './unit_edit_list.vue'
	import unitEditGroup from './unit_edit_group.vue'
	import unitEditProduct from './unit_edit_product.vue'
	import unitEditLinkArea from './unit_edit_link_area.vue'
	import {createStore, getStore, mapStore} from '@/submodule/assets/script/createStore.js'
	
	export default {
		components: {
			unitEditList,
			unitEditGroup,
			unitEditProduct,
			unitEditLinkArea
		},
		
		props: {
			pUnitStore: Object,
			config: Array,
			index: Number,
			value: Object
		},
		
		data() {
			let {unitStore: pUnitStore} = getStore(this, 'unitStore');
			return {
				unitStore: this.pUnitStore || pUnitStore || createStore({
					hidden: {},
					pointsProdut: {}
				}),
				
				dataValue: {},
				thumbValue: {}
			}
		},
		
		computed: {
			...mapStore('unitStore', ['hidden', 'pointsProdut'])
		},
		
		watch: {
			value(val) {
				this.set(val || {});
			}
		},
		
		mounted() {
			this.set(this.value || {});
		},
		
		methods: {
			unitHandle(unit, val) {
				unit.handle && unit.handle.call(this, val, this._backfill);
			},
			
			set(data, attach) {
				if (!attach) {
					this.config.forEach(item => {
						if ((item.type == 'radio' || item.type == 'group') && data[item.code] === undefined) {
							data[item.code] = item.options[0].value;
						} else if (item.type == 'thumb') {
							this.$set(this.thumbValue, item.code, data[item.code] === undefined ? item.options[0].value : data[item.code]);
						} else if (item.type == 'hidden') {
							data[item.code] = item.value;
						}
					});
				}
				
				this.$refs.form.set(data);
				this.$refs.complex && this.$refs.complex.forEach(item => {
					if (!attach || !item.code || data[item.code] !== undefined) {
						item.set(data);
					}
				});
				setTimeout(() => {
					delete this._backfill;
				}, 1000)
			},
			
			async submit() {
				let data = this.$refs.form.serialize();
				
				await Promise.all(Array.from(this.config.filter(item => data[item.code] && (item.widthParam || item.heightParam)), item => {
					return new Promise(resolve => {
						let img = new Image();
						img.onload = function() {
							item.widthParam && (data[item.widthParam] = img.width);
							item.heightParam && (data[item.heightParam] = img.height);
							resolve();
						}
						img.src = data[item.code];
					});
				}))
				
				if (this.$refs.complex) {
					for (let i = 0; i < this.$refs.complex.length; i++) {
						let temp = await this.$refs.complex[i].submit();
						data = Object.assign(data, temp);
					};
				}
				
				data = Object.assign(data, this.thumbValue);
				
				return data;
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
